<div class="w-100 dropdown">
    <div #dropdownToggle #dropdownReference class="source-filter-input form-control rounded-end"
         role="button" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false"
         (pointerdown)="setDropdownReference(dropdownReference)"
         (focusin)="setDropdownReference(dropdownReference)">
        <div class="d-flex align-items-center">
            <div class="flex-grow-1 m-0" style="min-width: 8rem">
                <ng-content select=".input-group-prefix"></ng-content>
                <input [(ngModel)]="inputModel" [placeholder]="placeholder"
                       [attr.type]="searching ? 'text' : 'search'" autocomplete="off" class="w-100 h-100 border-0 p-0 m-0"
                       (keydown.backspace)="removeSelectedItemWhenEmpty();"
                       [typeahead]="onInput" (selectItem)="onSelect($event.item); $event.preventDefault();"/>
            </div>
            <div class="source-filter-actions ms-2">
                <span class="input-group-append input-group-text border-0 bg-transparent p-0">
                    <span *ngIf="!inputModel || inputModel.requiresEditing"
                          class="bi {{newValueTemplate ? 'bi-plus-circle' : 'bi-search'}}"></span>
                </span>
                <ng-content select=".input-group-suffix"></ng-content>
            </div>
        </div>
        <ng-content select=".invalid-feedback"></ng-content>
        <ng-content select=".valid-feedback"></ng-content>
    </div>

    <ng-content select=".dropdown-menu"></ng-content>

    <div *ngIf="selectedItems.length > 0"
         class="selected-items d-flex flex-row flex-wrap align-items-center column-gap-1 row-gap-1 mt-2">
        <ng-container *ngFor="let v of selectedItems">
            <div>
                <span #selectedItemReference
                      class="selected-item-reference d-flex badge text-bg-info fw-normal"
                      style="font-size: 1rem !important;" role="button"
                      (pointerdown)="setDropdownReference(selectedItemReference)"
                      (click)="toggleDropdownFromSelectedItem($event, selectedItemReference)">
                    <span class="text-truncate">
                        <ng-container *ngIf="itemTemplate; else noTemplate"
                                      [ngTemplateOutlet]="itemTemplate"
                                      [ngTemplateOutletContext]="{$implicit: v}">
                        </ng-container>
                    </span>
                    <a *ngIf="!disabled" class="selected-item-remove text-decoration-none ms-2"
                       (pointerdown)="$event.preventDefault(); $event.stopPropagation()"
                       (click)="$event.preventDefault(); $event.stopPropagation(); deleteValue(v)"
                       type="button" style="color: white;">
                        <span class="notranslate">×</span>
                    </a>
                </span>
                <ng-template #noTemplate>{{formatter(v)}}</ng-template>
            </div>
        </ng-container>
        <button *ngIf="!disabled && selectedItems.length > 1"
                type="button"
                class="btn btn-link btn-sm text-muted text-decoration-none px-2 py-0"
                (pointerdown)="$event.preventDefault(); $event.stopPropagation()"
                (click)="$event.preventDefault(); $event.stopPropagation(); clearSelection()">
            Clear filters
        </button>
    </div>
</div>


<ng-content select=".input-group-prepend"></ng-content>
